import { IonCardContent, IonText, useIonToast } from '@ionic/react';
import { calendarOutline, keyOutline, personOutline, phonePortraitOutline } from 'ionicons/icons';
import { useEffect, useState } from 'react';

import ActionButton from '../../../../../components/button/ActionButton';
import InputItem from '../../../../../components/input/InputItem';
import { DataProvider } from '../../../../../library/DataProvider';
import { RegisterPostAction } from '../../../../../redux/actions/Account';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';

interface Props {
    registerDone: any
}

const Register: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()
    const formRegister = useAppSelector(state => state.register)
    const { form_loading, resp } = formRegister

    const [submit, setSubmit] = useState(false);

    const [form, setForm] = useState({
        name: { value: "", validation: { required: true }, error: "" },
        family: { value: "", validation: { required: true }, error: "" },
        mobile: { value: "", validation: { required: true, min: 11 }, error: "" },
        birth_date: { value: "", validation: { required: true }, error: "" },
        password: { value: "", validation: { required: true }, error: "" }
    });

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const formSubmitHandler = (e: any) => {
        e.preventDefault();

        let formValidation = formProvider.validation(form);

        if (formValidation) {
            setSubmit(true);

            dispatch(RegisterPostAction(form.name.value, form.family.value, form.mobile.value, form.birth_date.value, form.password.value, ""))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading && submit) {
                if (resp.result) {
                    //toast({ message: resp.message, duration: 2000, color: "primary" })

                    formProvider.reset();

                    props.registerDone(resp.uid, resp.activation_remained);

                    setSubmit(false);
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    return <IonCardContent>
        <form onSubmit={formSubmitHandler}>
            <div className="ion-text-justify ion-margin-bottom">
                <IonText>حامی طبیعت کسی است که با ثبت نام و دریافت کارت متعهد میشود هر ماه حداقل پنج هزار تومان در پروژه های نذرطبیعت حمایت داشته باشد.
                    ما با این پنج هزار تومان ها حیات‌وحش تشنه را سیراب میکنیم.</IonText>
            </div>

            <InputItem name="name" type="text" label="نام" icon={personOutline} maxlength={20} provider={formProvider} />

            <InputItem name="family" type="text" label="نام خانوادگی" icon={personOutline} maxlength={30} provider={formProvider} />

            <InputItem name="mobile" type="tel" label="تلفن همراه" icon={phonePortraitOutline} maxlength={11} ltr spaced provider={formProvider} />

            <InputItem name="birth_date" type="datepicker" dateType="birth" label="تاریخ تولد" icon={calendarOutline} maxlength={10} provider={formProvider} ltr spaced />

            <InputItem name="password" type="password" label="رمز عبور" icon={keyOutline} maxlength={20} ltr provider={formProvider} />

            <ActionButton text="ثبت نام" loading={form_loading} />
        </form>
    </IonCardContent>
}
export default Register